import { ChatEntity } from './entity';
import { omit } from 'lodash';
import { ChatMessage } from './message';
import { toLuxon } from '@app/api';
import { ChatUser } from './user';

export class ChatDiscussion extends ChatEntity {
  lastMessage?: ChatMessage;
  users: any[] = [];

  constructor(data: any) {
    super(data);

    this.update(data);
  }

  update(data: any) {
    if (data.lastMessage) {
      this.lastMessage = new ChatMessage(data.lastMessage);
    }

    if (data.users) {
      data.users = data.users.map((result: any) => {
        result.user = new ChatUser(result.user);
        return result;
      });
    }

    Object.assign(
      this,
      omit(data, ['type', 'created', 'createdTime', 'lastMessage']),
    );
  }

  isViewedUser(user: any) {
    const discussionUser = this.users.find((u: any) =>
      u.user.metas.find((m: any) => m.key == 'userId' && m.value == user.id),
    );
    return (
      user &&
      this.lastMessage &&
      (this.lastMessage.isSameUser(user) ||
        (discussionUser &&
          this.lastMessage.created <=
            (toLuxon(discussionUser.lastViewed) || 0)))
    );
  }
}
